import React, { useLayoutEffect, useRef } from 'react';

/** Measure content independently so frame resizing never scales the text. */
export function QuestPanel({ children }: { children: React.ReactNode }) {
    const frame = useRef<HTMLElement>(null);
    const content = useRef<HTMLDivElement>(null);
    useLayoutEffect(() => {
        const panel = frame.current;
        const body = content.current;
        if (!panel || !body || typeof ResizeObserver === 'undefined') return;
        const resize = () => {
            const style = getComputedStyle(panel);
            const trim = ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth']
                .reduce((sum, key) => sum + (parseFloat(style[key as keyof CSSStyleDeclaration] as string) || 0), 0);
            panel.style.height = `${body.getBoundingClientRect().height + (style.boxSizing === 'border-box' ? trim : 0)}px`;
        };
        resize();
        const observer = new ResizeObserver(resize);
        observer.observe(body);
        return () => observer.disconnect();
    }, []);
    return <aside ref={frame} className="quest-panel" tabIndex={0} aria-label="Quest summary and objective details"><div ref={content} className="quest-panel-content">{children}</div></aside>;
}
